import React from 'react';
import { Progress, FormInstance } from 'antd';
import { BulkWearableItem, LABEL_MAPS, getLabel } from './types';

interface BulkReviewStepProps {
  styles: { [key: string]: string };
  bulkItems: BulkWearableItem[];
  form: FormInstance;
}

const BulkReviewStep: React.FC<BulkReviewStepProps> = ({ styles, bulkItems, form }) => {
  const formValues = form.getFieldsValue();
  const bulkFormItems = formValues.bulkItems || [];

  return (
    <div className={styles.stepContainer}>
      <h2 className={styles.stepTitle}>Review and Submit</h2>

      <div className={styles.reviewSection}>
        <h3>Items ({bulkItems.length})</h3>
        {bulkItems.map((item, index) => {
          const formItem = bulkFormItems[index] || {};
          const name = formItem.itemName || item.itemName || `Item ${index + 1}`;
          return (
            <div key={`review-${item.itemId}-${index}`} className={styles.bulkItemCard} style={{ padding: '16px 20px', marginBottom: 12 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
                {item.image && (
                  <img src={item.image} alt={name} style={{ width: 48, height: 48, borderRadius: 6, objectFit: 'cover' }} />
                )}
                <strong style={{ fontSize: 16 }}>{name}</strong>
              </div>
              <div className={styles.reviewItem}>
                <span className={styles.reviewLabel}>Wearable Type</span>
                <span className={styles.reviewValue}>{formItem.wearableType || item.wearableType}</span>
              </div>
              <div className={styles.reviewItem}>
                <span className={styles.reviewLabel}>Material</span>
                <span className={styles.reviewValue}>{formItem.material || item.material}</span>
              </div>
              <div className={styles.reviewItem}>
                <span className={styles.reviewLabel}>Style</span>
                <span className={styles.reviewValue}>{formItem.style || item.style}</span>
              </div>
              <div className={styles.reviewItem}>
                <span className={styles.reviewLabel}>Fabric</span>
                <span className={styles.reviewValue}>{formItem.fabric || item.fabric}</span>
              </div>
              <div className={styles.reviewItem}>
                <span className={styles.reviewLabel}>Tags</span>
                <span className={styles.reviewValue}>{formItem.tags || item.tags}</span>
              </div>
              <div className={styles.reviewItem}>
                <span className={styles.reviewLabel}>Pricing Models</span>
                <span className={styles.reviewValue}>
                  {item.pricingModel.map(m => getLabel(m, LABEL_MAPS.pricingModel)).join(', ')}
                </span>
              </div>
              {item.pricingModel
                .filter(m => m !== 'free' && m !== 'freemium')
                .map(m => (
                  <div key={m} className={styles.reviewItem}>
                    <span className={styles.reviewLabel}>{getLabel(m, LABEL_MAPS.pricingModel)} Price</span>
                    <span className={styles.reviewValue}>${item.pricingDetails[m]?.price || 0} USD</span>
                  </div>
                ))}
            </div>
          );
        })}
      </div>

      <div className={styles.submissionStatus}>
        <h3>Submission Status</h3>
        <div className={styles.statusItem}>
          <span className={styles.statusLabel}>Review Progress</span>
          <Progress percent={100} status="success" className={styles.statusProgress} showInfo={true} />
        </div>
        <p className={styles.statusDescription}>
          Please review all the information above before final submission.
        </p>
      </div>
    </div>
  );
};

export default BulkReviewStep;
